import { GET, POST, PUT, DELETE } from './api'

const table = "favorites"

export const Create = async (params) => {
    return await POST(`/${ table }`, params, true);
}

export const Toggle = async (params) => {
    return await POST(`/${table}/toggle`, params, true);
}

export const Read = async (locale) => {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    return await GET(`/${ table }${query}`, true);
}

export const ReadWorkspace = async (locale) => {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    return await GET(`/${table}/workspace${query}`, true);
}

export const ReadOne = async (id) => {
    return await GET(`/${ table }/${id}?populate=*`, true);
}

export const Update = async (params, id) => {
    return await PUT(`/${ table }/${id}`, params, true);
}

export const Delete = async (id) => {
    return await DELETE(`/${ table }/${ id }`, true);
}

export const CreateFolder = async (params) => {
    return await POST(`/${table}/folders`, params, true);
}

export const UpdateFolder = async (id, params) => {
    return await PUT(`/${table}/folders/${id}`, params, true);
}

export const DeleteFolder = async (id) => {
    return await DELETE(`/${table}/folders/${id}`, true);
}

export const ReorderFolders = async (params) => {
    return await POST(`/${table}/folders/reorder`, params, true);
}

export const MoveFavorites = async (params) => {
    return await POST(`/${table}/move`, params, true);
}

export const ReorderFavorites = async (params) => {
    return await POST(`/${table}/reorder`, params, true);
}
 
